import { googleApiKey } from '../../config/index';
import { queryStringFromObject } from '../../core/util/string';
import { isEmpty } from '../util/empty';

const STATIC_MAP_API = 'https://maps.googleapis.com/maps/api/staticmap?';
const STATIC_STREET_VIEW_API = 'https://maps.googleapis.com/maps/api/streetview?';
const HIDE_BUSINESS_LABELS = 'feature:poi.business|element:labels|visibility:off';

const latLongString = (latLong: any) =>
  typeof latLong === 'string' ? latLong : `${latLong.latitude},${latLong.longitude}`;

const buildMapMarkers = ({ latLong, markers, centerMarker, customMarkers }: any) => {
  const mapMarkers = markers.map((marker: any) => `${marker.latitude},${marker.longitude}`);
  if (centerMarker) {
    mapMarkers.push(latLongString(latLong));
  }

  if (customMarkers && customMarkers.length) {
    customMarkers.forEach((marker: any) => {
      let anchorPoint =
        marker.anchorXCoord && marker.anchorYCoord
          ? `${marker.anchorXCoord},${marker.anchorYCoord}`
          : 'center';

      mapMarkers.push(`anchor:${anchorPoint}|icon:${marker.url}|${latLongString(marker.latLong)}`);
    });
  }

  return mapMarkers;
};

const buildMapUrl = ({
  latLong,
  width,
  height,
  zoom,
  markers,
  centerMarker = true,
  customMarkers = [],
  hideBusinessLabels,
}: any) => {
  const mapMarkers = buildMapMarkers({
    latLong,
    markers,
    centerMarker,
    customMarkers,
  });
  const mapOptions = {
    center: latLongString(latLong),
    zoom,
    size: `${width}x${height}`,
    maptype: 'roadmap',
    key: googleApiKey,
  };

  if (hideBusinessLabels) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'style' does not exist on type '{ center:... Remove this comment to see the full error message
    mapOptions.style = HIDE_BUSINESS_LABELS;
  }

  if (!isEmpty(mapMarkers)) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'markers' does not exist on type '{ cente... Remove this comment to see the full error message
    mapOptions.markers = mapMarkers;
  }

  return `${STATIC_MAP_API}${queryStringFromObject(mapOptions)}`;
};

const buildStreetViewUrl = (addressAttributes: any, width: any, height: any) => {
  const { address, city, state, latLong } = addressAttributes;

  if (isEmpty(latLong)) return null;

  const mapOptions = {
    location: latLongString(latLong),
    size: `${width}x${height}`,
    key: googleApiKey,
  };

  if (address && city && state) {
    mapOptions.location = `${address},${city},${state}`;
  }

  return `${STATIC_STREET_VIEW_API}${queryStringFromObject(mapOptions)}`;
};

export { buildMapUrl, buildStreetViewUrl };
